module.exports = __webpack_public_path__ + "static/image1993-3e5218e72395c63079ab30165e401b12.jpeg";